import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getConfigList(params) {
  return request({
    url: URL.sys.config,
    method: 'get',
    params
  })
}

export function delConfig(uuid) {
  return request({
    url: URL.sys.config + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

// 批量删除配置
export function batchDeleteConfig(keys) {
  return request({
    url: URL.sys.batchDeleteConfig,
    method: 'post',
    data: keys
  })
}
